export const tableCellsName = [
  'Keyword',
  'Type',
  'Number of Results',
  'Time',
  'Link'
]
